import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE_LETTERS = {
  'letters': [],
  'loading': false,
};

const INITIAL_STATE_ICC_STOCK = {
  'stock': [],
  'loading': false,
};

const INITIAL_STATE_ICC_SALES = {
  'sales': [],
  'loading': false,
};

export const icc = (state, action) => {
  return createReducer(INITIAL_STATE_LETTERS, {
    [ActionTypes.FETCHING_LETTERS]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_LETTERS]: (state, action) => ({
      ...state,
      'loading': false,
      'letters': action.response.data,
    }),
    [ActionTypes.FETCHED_LETTERS_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'letters': [],
    }),
  })(state, action);
};

export const iccStock = (state, action) => {
  return createReducer(INITIAL_STATE_ICC_STOCK, {
    [ActionTypes.FETCHING_ICC_STOCK]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_ICC_STOCK]: (state, action) => ({
      ...state,
      'loading': false,
      'stock': action.response.data,
    }),
    [ActionTypes.FETCHED_ICC_STOCK_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'stock': [],
    }),
  })(state, action);
};

export const iccSales = (state, action) => {
  return createReducer(INITIAL_STATE_ICC_SALES, {
    [ActionTypes.FETCHING_ICC_SALES]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_ICC_SALES]: (state, action) => ({
      ...state,
      'loading': false,
      'sales': action.response.data,
    }),
    [ActionTypes.FETCHED_ICC_SALES_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'sales': [],
    }),
  })(state, action);
};
